import { render, staticRenderFns } from "./syOutPup.vue?vue&type=template&id=30b4e9a2&scoped=true&"
import script from "./syOutPup.vue?vue&type=script&lang=js&"
export * from "./syOutPup.vue?vue&type=script&lang=js&"
import style0 from "./syOutPup.vue?vue&type=style&index=0&id=30b4e9a2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b4e9a2",
  null
  
)

export default component.exports